import React from "react";
import { graphql, useStaticQuery } from 'gatsby';
import { Link } from 'gatsby-plugin-react-i18next';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import * as styles from "./style.module.scss";

const { 
  capabilities,
  capabilities__imageWrap,
  capabilities__image,
  capabilities__newTag,
  capabilities__link,
  capabilities__featured,
  capabilities__text,
} = styles;

const queryString = graphql`
  query MyQuery {
    contentfulPageCustomisableContent(slug: { eq: "account-intelligence" }) {
      title
      url
      slug
      ogImage {
        gatsbyImageData(placeholder: NONE)
        description
      }
    }
  }
`;

const CapabilitiesCTA = ({ newCap = false }) => {
  const { t } = useTranslation();

  const data = useStaticQuery(queryString);

  const pageData = data.contentfulPageCustomisableContent;

  const image = getImage(pageData.ogImage);

  return (
    <section className={capabilities}>
      {pageData && (
        <Link
          to={`/${pageData.url}${pageData.slug}`}
          className={`${capabilities__link} ${capabilities__featured}`}
        >
          <div className={capabilities__imageWrap}>
            {image && (
              <GatsbyImage
                className={capabilities__image}
                image={image}
                alt={pageData.ogImage?.description}
              />
            )}
            {newCap && (
              <div className={capabilities__newTag}>{t('nav_new')}</div>
            )}
          </div>
          <p className={capabilities__text}>{pageData.title}</p>
        </Link>
      )}
    </section>
  );
};

export default CapabilitiesCTA;
